import NextLink, { LinkProps } from 'next/link';
import { useRouter } from 'next/router';
import { FC, ReactNode } from 'react';

interface INextLibLynxLoginLinkProps extends Omit<LinkProps, 'href' | 'as'> {
  children: ReactNode;
}

export const NextLibLynxLoginLink: FC<INextLibLynxLoginLinkProps> = ({ children, ...rest }) => {
  const router = useRouter();

  return (
    <NextLink
      href={`${process.env.NEXT_PUBLIC_BASE_URL}liblynx/login?target=/${router.asPath}`}
      {...rest}
      legacyBehavior
    >
      {children}
    </NextLink>
  );
};
